<template>
  <div>

    <nav class="navbar customNavbar">
      <div class="navbar-brand">
        <a v-on:click="root()">
          <img class="logoClass" src="/static/logo.png">
        </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item customNavbarItem" v-on:click="about()">Nosotros</a>
        <a class="navbar-item customNavbarItem" v-on:click="products()">Productos</a>
        <a class="navbar-item customNavbarItem" v-on:click="news()">Noticias</a>
        <a class="navbar-item customNavbarItem" v-on:click="contact()">Contacto</a>
        <a class="navbar-item customNavbarItem" v-if="isLogged" v-on:click="logout()">Cerrar Sesión</a>
        <a class="navbar-item customNavbarItem" v-else v-on:click="login()">Iniciar Sesión</a>
      </div>
    </nav>

    <section class="section">
      <div class="columns">
        <div class="column"></div>
        <div class="column is-two-thirds">
          <h2 class="title is-2">Resultados de busqueda</h2>
          <br/>
          <div class="columns">
            <div class="column"></div>
            <div class="column is-6">
              <div class="field has-addons">
                <p class="control is-expanded">
                    <input v-model="searchText" :class="{'input': true, 'is-danger': errors.has('searchText') }" type="text" name="searchText" />
                    <span v-show="errors.has('searchText')" class="help is-danger">{{ errors.first('searchText') }}</span>
                </p>
                <div class="control">
                    <button class="button customButton" v-on:click="searchAgain">Buscar</button>
                </div>
              </div>
            </div>
            <div class="column"></div>
          </div>
          <article class="message is-info" v-for="searchItem of searchList" >
            <div class="message-body">
              <div class="searchContent" style="height: 70px">
                <h2 class="searchTitle"><i><b>{{searchItem.description}}</b></i></h2>
                <a class="newsLink" style="margin-top: 30px;" v-on:click="searchDetail(searchItem.link)">Ver más</a>
              </div>
            </div>
          </article>
        </div>
        <div class="column"></div>
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <div class="columns">
          <div class="column">
            <img class="logoClass" src="/static/logo.png">
            <p class="footerInfo">
              Nuestra misión es aportar soluciones para el control integrado de plagas que afectan la salud, la
              tranquilidad y la economía del hombre en las diferentes áreas donde se desenvuelve, por medio de
              asesoría técnica profesional, capacitación y productos efectivos a precios justos.
            </p>
          </div>
          <div class="column is-4">
            <a href="https://www.google.com/maps/@14.5945742,-90.5766572,17.25z" >
              <img width="400px" height="300px" class="mapInfo" src="/static/images/newmap.png"/>
            </a>
          </div>
          <div class="column">
            <p class="footerContact">
              2da calle 18-87 sector B-1<br/>
              Ciudad San Cristóbal zona 8 de Mixco<br/>
              Guatemala<br/>
              (502) 2478-1179 / 80 / 82 / 99<br/><br/>
              <a href="https://wa.me/50240251346">
                <img width="20px" height="20px" src="/static/images/whatsapp-icon.png" class="iconImage">
                WhatsApp: (502) 4025 - 1346
              </a><br/><br/>
              <a href="mailto:ventas@hipromeasa.com">
                <img width="20px" height="20px" src="/static/images/mail-icon.png" class="iconImage">
                E-Mail: ventas@hipromeasa.com
              </a><br/><br/>
              <a href="https://www.facebook.com/hipromeasa">
                <img width="20px" height="20px" src="/static/images/facebook-icon.png" class="iconImage">
                Estamos en Facebook
              </a>
            </p>
          </div>
        </div>
        <div class="content has-text-centered">
          <p class="footerLast">2025 - Todos los derechos reservados</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import ApiClient from '@/api/ApiClient.js'
export default {
  name: 'landing',
  data () {
    return {
      isLogged: localStorage.getItem('email') !== null,
      searchList: [],
      searchText: ''
    }
  },
  methods: {
    root: function () {
      this.$router.push('/')
    },
    logout: function () {
      localStorage.removeItem('email')
      localStorage.removeItem('token')
      this.isLogged = false
      this.$router.push('/')
    },
    about: function () {
      this.$router.push('/about')
    },
    products: function () {
      this.$router.push('/products')
    },
    news: function () {
      this.$router.push('/news')
    },
    contact: function () {
      this.$router.push('/contact')
    },
    login: function () {
      this.$router.push('/login')
    },
    searchDetail: function (searchId) {
      this.$router.push(searchId)
    },
    searchAgain () {
      console.log(this.searchText)
      ApiClient.search(this.searchText).then(response => {
        if (response.data.success) {
          this.searchList = response.data.results
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    }
  },
  created () {
    this.searchText = this.$route.params.search
    this.searchAgain()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logoClass {
    height: 60px;
    width: 220px;
    margin-left: 20px;
    margin-top: 10px;
  }
  .newsTitle {
      font-size: medium;
      text-align: left;
  }
  .newsInfo {
    font-size: smaller;
    text-align: left;
  }
  .newsLink {
    font-size: smaller;
    float: right;
  }
  .newsImage {
    margin-right: 50px;
  }
  .newsContent {
    margin-bottom: 20px;
  }
  .footerInfo {
    margin-left: 60px;
    margin-right:60px;
    text-align: center;
    font-size: small;
  }
  .footerContact {
    text-align: left;
    font-size: small;
    margin-left: 100px;
    margin-right:80px;
    margin-top: 30px;
  }
  .footerLast {
    font-size: small;
    margin-bottom: 0px;
    margin-top: -10px;
  }
  .mapInfo {
    padding-top: 30px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .iconImage {
    vertical-align: middle;
    padding-bottom: 2px;
  }
</style>



// WEBPACK FOOTER //
// SearchComponent.vue?5838ee80